import { IntlProvider } from "use-intl";
import { messages as appMessages } from "../constants/app-messages";
import { TranslationProviderProps } from "./types";
import { AntTranslationProvider } from "./ant-translation-provider";

export function TranslateProvider({
  locale,
  children,
}: TranslationProviderProps) {
  return (
    <AppTranslationProvider locale={locale}>
      <AntTranslationProvider locale={locale}>
        {children}
      </AntTranslationProvider>
    </AppTranslationProvider>
  );
}

function AppTranslationProvider({
  children,
  locale,
}: TranslationProviderProps) {
  return (
    <IntlProvider
      locale={locale}
      timeZone={Intl.DateTimeFormat().resolvedOptions().timeZone}
      messages={appMessages[locale]}
      getMessageFallback={({ key }) => key}
    >
      {children}
    </IntlProvider>
  );
}
